import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import BCMustRefer from "../../BCMustRefer.js";
import ClauseCard from "../../BCClauseCard.js";
import clauseData from "../../../data/BritishColumbia/clauseData.js";
import clauseCardDesc from "../../../data/BritishColumbia/clauseCardDescription.js";
import importantNotes from "../../../data/BritishColumbia/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";
import "../../../styles/ChecklistCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function AssignmentPurchase() {
  const [SellerRep, setSellerRep] = useState("No");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [ListingType, setListingType] = useState("MLS");
  const [BuyerRep, setBuyerRep] = useState("a Client");

  const [BuyerDocs, setBuyerDocs] = useState([
    "Disclosure of Representation in Trading Services",
    "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
    "Privacy Notice and Consent Form",
    "Related FINTRAC Documents",
  ]);

  const [DealDocs, setDealDocs] = useState([
    "Assignment of Contract of Purchase & Sale",
    "Original Purchase Contract",
    "Addendums (if applicable)",
    "Property Disclosure Statement or PNDS",
    "Buyers Advisement (highly recommended)",
    "Disclosure of Remuneration",
    "Title Search (if applicable)",
    "Copy of Deposit & Receipt",
    "Full REALTOR® SOLD MLS Printout",
  ]);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const addDisclosure = (e) => {
    setIsDisclosure("Yes");
    if (
      DealDocs.includes("Disclosure of Interest in Trade (BCFSA Form)") === true
    ) {
      return;
    } else {
      setDealDocs([
        ...DealDocs,
        "Disclosure of Interest in Trade (BCFSA Form)",
      ]);
    }
  };

  const removeDisclosure = (e) => {
    setIsDisclosure("No");
    setDealDocs(
      DealDocs.filter(
        (item) => item !== "Disclosure of Interest in Trade (BCFSA Form)",
      ),
    );
  };

  const setExclusive = (e) => {
    setListingType(e.target.value);
    let newDealDocs = [...DealDocs];
    if (
      SellerRep === "No" &&
      !newDealDocs.includes("Confirm Remuneration amount with LA, in writing")
    ) {
      newDealDocs.push("Confirm Remuneration amount with LA, in writing");
    }

    newDealDocs = newDealDocs.filter(
      (item) => item !== "Full REALTOR® SOLD MLS Printout",
    );

    setDealDocs(newDealDocs);
  };

  const setMLS = (e) => {
    setListingType(e.target.value);
    let newDealDocs = [...DealDocs];
    if (!newDealDocs.includes("Full REALTOR® SOLD MLS Printout")) {
      newDealDocs.push("Full REALTOR® SOLD MLS Printout");
    }

    newDealDocs = newDealDocs.filter(
      (item) => item !== "Confirm Remuneration amount with LA, in writing",
    );

    setDealDocs(newDealDocs);
  };

  const handleSellerRep = (e) => {
    setSellerRep(e.target.value);
    if (e.target.value === "Yes") {
      setListingType("MLS");
      let newDealDocs = [...DealDocs];

      newDealDocs = newDealDocs.filter(
        (item) =>
          item !== "Disclosure of Remuneration" &&
          item !== "Buyers Advisement (highly recommended)" &&
          item !== "Confirm Remuneration amount with LA, in writing",
      );

      if (newDealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
        setDealDocs(newDealDocs);
      } else {
        newDealDocs.push("Full REALTOR® SOLD MLS Printout");
        setDealDocs(newDealDocs);
      }
    }
    if (e.target.value === "No") {
      if (e.target.value === SellerRep) {
        return;
      }
      setBuyerRep("a Client");
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
      if (ListingType === "Exclusive") {
        DealDocs.push("Confirm Remuneration amount with LA, in writing");
      }

      DealDocs.splice(3, 0, "Buyers Advisement (highly recommended)");
      DealDocs.splice(4, 0, "Disclosure of Remuneration");
    }
  };

  const handleBuyerRep = (e) => {
    setBuyerRep(e.target.value);
    if (e.target.value === "a Client") {
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
    } else {
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Disclosure of Risks to Unrepresented Parties",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
    }
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="pr-5 pt-3">
            Do you also represent the Assignor (Seller) in this transaction?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {SellerRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">
                Assignee's (Buyer) Representation?
              </div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="a Client"
                    value={BuyerRep}
                  >
                    <FormControlLabel
                      value="a Client"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="an Unrepresented Party"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Unrepresented Party"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
          <div className="pr-5 pt-5">Type of Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="MLS"
                value={ListingType}
              >
                <FormControlLabel
                  value="MLS"
                  control={<Radio size="small" onClick={setMLS} />}
                  label="MLS"
                />
                <FormControlLabel
                  value="Exclusive"
                  control={<Radio size="small" onClick={setExclusive} />}
                  label="Exclusive"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-5">
            {SellerRep === "No"
              ? `Are you or immediate family members purchasing this Contract?`
              : `Are you or any of your close relatives the Assignee or the Assignor?`}
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={addDisclosure} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={removeDisclosure} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div className="pt-5 pr-3">
            <div className="clause-warning">
              <div className="clause-warning-icon">
                <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
              </div>
              <div>
                Assignments can be very complex transactions. If the outcome of
                the Assignment is negative or you have any questions, please
                contact your Managing Broker immediately.
              </div>
            </div>
          </div>
        </div>
      </div>

      {SellerRep === "Yes" && BuyerRep === "a Client" ? (
        <BCMustRefer IsMLS={ListingType} />
      ) : (
        <>
          <ChecklistCard
            province={"BC"}
            CheckListData={BuyerDocs}
            CheckListData2={DealDocs}
            Header={"Purchase:"}
            Header2={"Assignee is " + BuyerRep}
            Title1="Assignee Documents"
            Title2="Deal Documents"
          />
        </>
      )}

      {SellerRep === "Yes" &&
      BuyerRep === "a Client" &&
      IsDisclosure === "Yes" ? (
        ""
      ) : (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter(
            (item) =>
              item.category.includes("residential") ||
              item.category.includes("assignPurchase"),
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              (item.category.includes("residential") ||
                item.category.includes("assignPurchase")) &&
              item.isCommon === "yes",
          )}
          ClauseDataSituational={clauseData.filter(
            (item) =>
              (item.category.includes("residential") ||
                item.category.includes("assignPurchase")) &&
              item.isCommon === "no",
          )}
        />
      )}

      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>

        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true,
            )}
          />
        ) : (
          ""
        )}

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("assignPurchase") === true,
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
